import styled from 'styled-components';

import { AdornedInput, Input, Spacer, token } from '@zillow/constellation';

export const StyledAdornedInput = styled(AdornedInput)`
  & ${Input} {
    border: none;
    padding-left: 16px;
  }
  border-radius: 4px;
  border: 1px solid #d1d1d5;
  :active,
  :focus,
  :hover {
    border-color: #006aff;
  }
  &label {
    border: none;
  }
  label[class^='StyledAdornment'] {
    border: none;
  }
`;

export const StyledDropdownContainer = styled.div`
  background-color: white;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  margin: 0 1px;
  left: 0;
  max-height: 200px;
  overflow: scroll;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 1000;
`;

export const StyledDropdownItem = styled(Spacer)`
  &:hover {
    background: ${token('colors.gray100')};
  }
`;

export const StyledMultiselect = styled.div`
  position: relative;
`;
